import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { insertUpdateLiqaureLicense_action, getLiquareLicenseDetails_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/liquoreLicense_action/liquoreLicense_action'
import Modal from "react-modal";
import { data } from "jquery";
import $ from 'jquery'
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";
// 
class LiquareLicense extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      PowerConnectionList: [],
      Is_Agree: false,
      Is_Agree2: false,
      Remark: "",
      CGST: "",
      SGST: "",
      Is_AgreeErr: "",
      Is_Agree2Err: "",
      DeadlineDate: "",
      Is_Required: true,
      LiquorLicenseID: "",
      currentDate: moment().format("DD-MM-YYYY"),
      contactDetailsList: [],
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)


    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addLiquorLicense()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    this.getLiquorLicenseDetails()
    this.loadscript()
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back()
  }

  inputValidate() {
    const { Is_Agree, Is_Agree2 } = this.state

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: 'kindly agree to request liquor license' })
    }
    if (Is_Agree2 == 0 || Is_Agree2 == false) {
      this.setState({ Is_Agree2Err: 'kindly agree to disclaimer for liquor license permissions kindly agree to request liquor license' })
    }
  }

  getLiquorLicenseDetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state
    this.setState({ isLoading: true })
    this.props
      .getLiquareLicenseDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, contactDetailsList: data.contactDetails, })
          if (data.data != '') {
            this.setState({
              LiquorLicenseID: data.data[0]['LiquorLicenseID'],
              Is_Agree: data.data[0]['isRequiredForLiquorLicense'],
              Is_Agree2: data.data[0]['IsAgree'],
              Remark: data.data[0]['Remark'],
            })
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addLiquorLicense() {
    const { Remark, Is_Agree, LiquorLicenseID, Is_Agree2 } = this.state
    this.inputValidate()
    this.setState({ isLoading: true })
    if (Is_Agree && Is_Agree2) {
      const ManualFormsID = this.props.location.state?.ManualFormsID || null;
      const ServiceID = this.props.location.state?.ServiceID || null;
      const VendorDetails = this.props.location.state?.VendorDetails || {};
      this.props
        .insertUpdateLiqaureLicense_action(
          LiquorLicenseID,
          Is_Agree,
          Remark,
          Is_Agree2,
          ManualFormsID,
          ServiceID,
          VendorDetails
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(
              this.state.StatusID == 0
                ? "Liqaure License Form Submitted Successfully"
                : "Liqaure License Form Updated Successfully"
            );
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Plase Enter mandatory feilds!")
      this.inputValidate()
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { isLoading, Is_Agree, isOpenConfirmationModal, Remark, Is_AgreeErr, currentDate, contactForLiquorLicense, DeadlineDate, Is_Agree2, Is_Agree2Err, contactDetailsList, StatusID, isHideSection, is_View } = this.state
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 pt-1 shadow-none">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px", paddingTop: "5px" }}>
                      Liquor License
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection && (
                      <ul style={{ lineHeight: "25px", textAlign: "left", padding: 0 }}>
                        <li>
                          1) The cost/rates and terms & conditions of utilizing the individual
                          services from the given service provider is solely discretion of
                          exhibitors.
                        </li>
                        <li>
                          2) India ITME Society is only information facilitator for the service
                          provider & In no event shall INDIA ITME SOCIETY be liable for any
                          direct, indirect, punitive, incidental, special consequential issues,
                          whatsoever arising out of taking services with the above given service
                          provider.
                        </li>
                      </ul>
                    )}
                    <VendorDetails />
                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2 " >
                          Liquor License{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}
                    <strong>
                      <p className="m-0">Contact Details:-</p>
                    </strong>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {contactDetailsList != "" && contactDetailsList.length > 0 ? (
                        contactDetailsList.map((data) => (
                          <>
                            <div
                              class="table-responsive w-50"
                              style={{
                                backgroundColor: "#ebebeb",
                                marginBottom: "14px",
                                borderRight: "1px solid lightgray",
                              }}
                            >
                              <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                                <p className="m-0">
                                  <strong>Name:</strong> {data.Name}{" "}
                                </p>
                                <p className="m-0">
                                  <strong>Phone:</strong> {data.Phone}
                                </p>
                                <p className="m-0">
                                  <strong>Mobile No.</strong> {data.Mobile}
                                </p>
                                <p className="m-0">
                                  <strong>Email:</strong> {data.PrimaryEmail}
                                </p>
                                <p className="m-0">
                                  <strong>Alternate E-mail:</strong> {data.SecondaryEmail}
                                </p>
                                <p className="m-0">
                                  <strong>Address:</strong> {data.Address}
                                </p>
                              </div>
                            </div>
                          </>
                        ))
                      ) : (
                        <div
                          class="table-responsive w-50"
                          style={{
                            backgroundColor: "#ebebeb",
                            marginBottom: "14px",
                            borderRight: "1px solid lightgray",
                          }}
                        >
                          <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                            <p className="m-0">No record found </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div class="row m-1">
                  <form>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={isDeadlinePassed || is_View}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      <strong>I want to request liquor license.</strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                    <strong>
                      {" "}
                      <label>Remark</label>{" "}
                    </strong>
                    <textarea
                      class="form-control"
                      value={Remark}
                      onChange={(e) => this.setState({ Remark: e.target.value })}
                      disabled={isDeadlinePassed || is_View}
                      maxLength={300}
                      rows="3"
                    ></textarea>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree2}
                        disabled={isDeadlinePassed || is_View}
                        onChange={(e) =>
                          this.setState({ Is_Agree2: e.target.checked, Is_Agree2Err: "" })
                        }
                      />
                      <strong>
                        I agree the above disclaimer for liquor license permissions
                        <span className="required">*</span>.
                      </strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_Agree2Err}
                      </span>
                    }
                  </form>
                </div>
              </div>
              {!isHideSection && (
                <div className="row">
                  {isDeadlinePassed && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}
              {!isHideSection && (
                <div class="d-flex justify-content-end mt-0">
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block"
                    style={{ marginRight: 10 }}
                    disabled={currentDate > DeadlineDate}
                    // onClick={() => this.addLiquorLicense()}
                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                  >
                    {this.state.StatusID == 0 ? "Submit" : "Update"}
                  </button>
                  <button
                    className="btn btn-gray rounded-1 d-block"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(null, { insertUpdateLiqaureLicense_action, getLiquareLicenseDetails_action })(LiquareLicense));